"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = void 0;
var endSlash = new RegExp(/\/$/);
var startSlash = new RegExp(/^\//);
var assembleUrl = function (base) { return function (path) {
    var cleanBase = base.replace(endSlash, '');
    var cleanPath = path.replace(startSlash, '');
    return cleanBase + "/" + cleanPath;
}; };
var buildUrl = function (base, path) { return assembleUrl(base)(path); };
exports.buildUrl = buildUrl;
